import 'styled-components';

const mediumBlue = '#4AAFE0';
const darkBlue = '#2c3c8a';
const lightBlue = '#e8f6f5';
const yellow = '#ede412';
const red = '#db2d89';
const magenta = '#b7007b';
const violet = '#7809B8';
const darkGreen = '#007334';
const orange = '#eb8c00';

const theme = {
  colors: {
    blue: Object.assign(mediumBlue, {
      dark: Object.assign(darkBlue, {
        hover: '#4C5BA4',
        inactive: '#8A99BF',
      }),
      light: '#A4D7F0',
      semiLight: '#6ABDE4',
    }),
    turquoise: Object.assign('#8bd2ce', {
      light: lightBlue,
      semiLight: '#C3E4F4',
      hover: '#A6D4D1',
    }),
    white: Object.assign('#ffffff', {
      opacity: 'rgba(255, 255, 255, 0.2)',
    }),
    black: Object.assign('#171717', {
      opacity: 'rgba(0, 0, 0, 0.5)',
    }),
    yellow: Object.assign(yellow, {
      light: '#F1EC6B',
    }),
    red,
    magenta,
    violet,
    darkGreen,
    orange,
    gray: Object.assign('#E6E6E6', {
      dark: '#B6B6B6',
      light: '#f3f3f3',
    }),
  },

  fonts: {
    barlow: '\'Barlow\', sans-serif;',
    baloo: '\'Baloo 2\', sans-serif;',
  },
};

export default theme;
